import { render, staticRenderFns } from "./SponsorsByAdFrequency.vue?vue&type=template&id=3c90c766&"
import script from "./SponsorsByAdFrequency.vue?vue&type=script&lang=js&"
export * from "./SponsorsByAdFrequency.vue?vue&type=script&lang=js&"
import style0 from "./SponsorsByAdFrequency.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports